<template>
  <v-card>
    <v-card-title>
      Leads
    </v-card-title>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <v-card-subtitle> Total de {{ total_leads }} Leads </v-card-subtitle>
    <GraphicColumn
      v-if="showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn"),
    GraphicLine: () => import("./GraphicLine")
  },

  data() {
    return {
      categories: [],
      total_leads: 0,
      titleY: "Leads",
      titleX: "Empresa",
      chartSeries: [
        {
          name: "Leads",
          color: "#CC152C",
          data: [],
          showInLegend: true
        },
        {
          name: "Percentual",
          data: [],
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}%",
            x: 5
          },
          tooltip: {
            valueSuffix: "%"
          }
        }
      ],
      date_init: "",
      date_end: "",
      isCompany: false,
      company: [],
      showCard: false
    };
  },
  methods: {
    async init() {
      var dataValue = [];
      var dataValueColumn = [];
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/leads");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          const objsExample = {
            result: [
              {
                total_simulado: 3,
                total_all: 16,
                percentual: 18.75,
                empresa: "04926895000221"
              },
              {
                total_simulado: 7,
                total_all: 16,
                percentual: 43.75,
                empresa: "17323085000222"
              },
              {
                total_simulado: 5,
                total_all: 16,
                percentual: 31.25,
                empresa: "32950875000140"
              },
              {
                total_simulado: 1,
                total_all: 16,
                percentual: 6.25,
                empresa: "04130726000108"
              }
            ]
          };
          console.clear();
          console.log("leads.page");
          const leadsff = this.getLeadFromFirestore;
          this.total_leads = leadsff[0].total_all;
          var tmp = [];
          this.getEmpresas.forEach((e, c) => {
            tmp = [];
            tmp = leadsff.filter(a => {
              return a.empresa == e.cnpj;
            });
            dataValue.push(tmp.length > 0 ? Number(tmp[0].total_simulado) : 0);
            dataValueColumn.push(
              tmp.length > 0 ? Number(tmp[0].percentual) : 0
            );
            dataCategorie.push(e.apelido);
          });
        })
        .catch(erro => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie).then(a => {
        this.showCard = !this.showCard;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.chartSeries[1].data = dataValueColumn;
      });
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter", "getLeadFromFirestore"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    }
  }
};
</script>

<style lang="scss"></style>
